import initGlobals from './js-core/global/global-main'
import env from "./env"

//TODO all env from package.json!!
initGlobals(env)

import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;